import { generateVariantData } from '../../../../experiments/utils';

const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/flagship`;

const variantToDataMapping = {
  base: {
    title: 'Help make 15 minutes of learning possible for every child, every day',
    body:
      'For all HOMER by Begin purchases made by September 1st, Begin will donate learning products to families from underserved communities through our partnership with Jumpstart.',
    cta: {
      ctaLabel: 'Get Started',
    },
    componentName: 'Beginwith15',
    learnMore: {
      link: 'https://beginlearning.com/15minutes',
      linkText: 'Learn more about Begin with 15',
    },
    image: `${imgURL}/begin/begin-jumpstart.png`,
    imageAlt: 'Begin partnership with Jumpstart',
    imageSubtitle:
      'Jumpstart is a national nonprofit dedicated to providing comprehensive early childhood education to all.',
  },
};

export const getBeginPromotionalVariantData = generateVariantData(variantToDataMapping);



// WEBPACK FOOTER //
// ./src/containers/Home/sections/BeginPromotional/beginPromotionalData.js